import styled from 'styled-components';

const StyledWrapper = styled.div`
  &:has(.user-dropdown.open) {
    .overlay {
      display: block;
    }
  }

  &:has(aside.open) {
    .content {
      grid-template-columns: 130px calc(100% - 130px);
    }
  }
  
  .overlay {
    position:fixed;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.4);
    z-index: 100;
    display: none;
  }
  
  .content {
    display: grid;
    grid-template-rows: 80px calc(100% - 80px);
    grid-template-columns: 76px calc(100% - 76px);
    grid-template-areas: "aside head"
                       "aside main";
    min-width: 900px;
    background-color: ${(p) => p.theme.colors.background_dashboard};
  }
`;

export default StyledWrapper;
